import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordAppleSearchAdsV1Body } from './record-apple-search-ads-v1-request';
import type { IRecordAppleSearchAdsV1Response } from './record-apple-search-ads-v1-response';
import { recordAppleSearchAdsV1ResponseSchema } from './record-apple-search-ads-v1-response';

export async function recordAppleSearchAdsV1Api(
  body: IRecordAppleSearchAdsV1Body,
): Promise<IValidatedResponse<IRecordAppleSearchAdsV1Response>> {
  return postRequest<IRecordAppleSearchAdsV1Response>({
    path: '/account/install-source/apple/v1',
    body,
    schema: recordAppleSearchAdsV1ResponseSchema,
  });
}
